<template>
  <div class="flex items-center gap-4">
    <BaseMemberAvatar size="80" :member="user" :omit-tooltip="true" />
    <div>
      <p class="text-display-small md:text-display-medium">
        {{ $t('app.hello') }} {{ user.firstName }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useUserStore } from '@/stores/user.store'
  import BaseMemberAvatar from '../../../core/components/base/avatar/BaseMemberAvatar.vue'

  const { user } = await useUserStore()
</script>
